<div class="app-maintenance flex flex-col flex-auto items-center justify-center min-h-screen w-full p-6 sm:p-10 bg-gray-50 dark:bg-gray-900">
    <div class="max-w-lg w-full rounded-2xl bg-card shadow p-8 sm:p-10 text-center">
        <img
            *ngIf="logo"
            class="mx-auto h-16 w-auto mb-8"
            [src]="logo"
            [alt]="appName + ' logo'" />

        <div class="inline-flex items-center justify-center w-14 h-14 rounded-full bg-amber-100 text-amber-800 mb-6" *ngIf="!logo">
            <span class="text-2xl font-semibold">!</span>
        </div>

        <h1 class="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">
            Under maintenance
        </h1>

        <p class="mt-4 text-secondary leading-relaxed">
            {{ message }}
        </p>

        <p class="mt-8 text-sm text-secondary">
            Need help?
            <a class="text-primary font-medium hover:underline" [href]="'mailto:' + supportEmail">{{ supportEmail }}</a>
        </p>
    </div>
</div>
